import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { LoaderWithText } from 'app/shared/loader/loader-with-text';
import { UseQueryResult } from '@tanstack/react-query';

type QueryResult<T> = UseQueryResult<T, unknown>;

export interface IWithRouteLoader {
  loaderFunction: (caseUuid: string) => QueryResult<any>;
  children: any
}

const RouterPreloadData = ({ loaderFunction, children }: IWithRouteLoader) => {
  const params = useParams();

  const { data, isLoading } = loaderFunction(params.id);

  if (isLoading) return <LoaderWithText>{children}</LoaderWithText>;
  return React.cloneElement(children, { loaderData: data });

};

export default RouterPreloadData
